import React from "react";
import { Row } from "common/components";
import { ControlLabel } from "components/bootstrap";
import OwnerLabel from "security-app/components/SecurityEvents/Alerts/EventDetails/OwnerLabel";
const OwnerAction = ({ securityEvent }) => /* @__PURE__ */ React.createElement(Row, { $gap: "xs", $align: "center", $width: "auto" }, /* @__PURE__ */ React.createElement(ControlLabel, { style: { margin: 0 } }, "Owner"), /* @__PURE__ */ React.createElement(OwnerLabel, { securityEvent }));
export default OwnerAction;
